<template>
<div id="notice_part" ref="notice_part">
  <div class="container">
    <div class="content">
      <!-- noticeSelect[0] -->
      <div id="notice1" v-if="tour.noticeSelect[0]!==null || tour.noticeInput[0].length>0">
        <h6 class="nav_title mt-5">{{ $t('notice1') }}</h6>
        <div class="px-4" v-html="tour.noticeSelect && tour.noticeSelect[0]"></div>
        <div class="px-4" v-html="tour.noticeInput && tour.noticeInput[0]"></div>
      </div>
      <!-- noticeSelect[1] -->
      <div id="notice2" v-if="tour.noticeSelect[1]!==null || tour.noticeInput[1].length>0">
        <h6 class="nav_title mt-5">{{ $t('notice2') }}</h6>
        <div class="px-4" v-html="tour.noticeSelect && tour.noticeSelect[1]"></div>
        <div class="px-4" v-html="tour.noticeInput && tour.noticeInput[1]"></div>
      </div>
    </div>
  </div>
      <!-- noticeSelect[2] -->
  <div class="container pb-3">
    <div id="notice3" v-if="tour.noticeSelect[2]!==null || tour.noticeInput[2].length>0">
      <h6 class="nav_title mt-5">{{ $t('notice3') }}</h6>
      <div class="px-4" v-html="tour.noticeSelect && tour.noticeSelect[2]"></div>
      <div class="px-4" v-html="tour.noticeInput && tour.noticeInput[2]"></div>
    </div>
      <!-- noticeSelect[3] -->
    <div id="notice4" v-if="tour.noticeSelect[3]!==null || tour.noticeInput[3].length>0">
      <h6 class="nav_title mt-5">{{ $t('notice4') }}</h6>
      <div class="px-4" v-html="tour.noticeSelect && tour.noticeSelect[3]"></div>
      <div class="px-4" v-html="tour.noticeInput && tour.noticeInput[3]"></div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  props: {
    tour: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
#notice_part {
  background-color: #eee;
  li {
    list-style: circle;
    margin-bottom: .5rem;
  }
  .content {
    margin-bottom: 3.5rem;
  }
}
// #notice_part1 {
//   padding: calc(10px + 1vw) 0;
//   // background-color: #eee;
// }
// #notice_part2 {
//   // background-color: #fff;
//   padding: calc(10px + 1vw) 0;
// }
</style>
